<template>
  <section class="box as-home-history display-pc">
    <div class="container">
      <com-h1 class="light" style="margin-top: 0" title="往届回顾"></com-h1>
      <a @mouseover="mouseover('bj2014')" :class="{animate: this.curKey==='bj2014'}" class="y2014 bj" href="http://bj2017.archsummit.com/" target="_blank">
        <span>2017·北京</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('sz2017')" :class="{animate: this.curKey==='sz2017'}" class="y2017 sz" href="http://sz2018.archsummit.com/" target="_blank">
        <span>2017·深圳</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('bj2016')" :class="{animate: this.curKey==='bj2016'}" class="y2016 bj" href="http://bj2017.archsummit.com/" target="_blank">
        <span>2018·北京</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('sz2016')" :class="{animate: this.curKey==='sz2016'}" class="y2016 sz" href="http://bj2016.archsummit.com/" target="_blank">
        <span>2016·北京</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('bj2015')" :class="{animate: this.curKey==='bj2015'}" class="y2015 bj" href="http://sz2018.archsummit.com/" target="_blank">
        <span>2018·深圳</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('sz2019')" :class="{animate: this.curKey==='sz2019'}" class="y2019 sz" href="https://archsummit.infoq.cn/2019/shenzhen/" target="_blank">
        <span>2019·深圳</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
      <a @mouseover="mouseover('bj2019')" :class="{animate: this.curKey==='bj2019'}" class="y2019 bj" href="https://archsummit.infoq.cn/2019/beijing/" target="_blank">
        <span>2019·北京</span>
        <span class=line></span>
        <span class="dot"><span class="in"></span><span class="out"></span></span>
      </a>
    </div>
  </section>
</template>

<script>
import ComH1 from '@/components/com-h1'

export default {
  components: {
    ComH1
  },
  props: [],
  data () {
    return {
      curKey: 'sz2019'
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    mouseover (key) {
      this.curKey = key
    }
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

@keyframes ashomehistoryblink
  0%
    transform: scale(1,1)
  100%
    transform: scale(1.6,1.6)

.as-home-history
  height: 507px
  background-color: rgb(38,48,86)
  background-image: url('https://static.geekbang.org/infoq/58ed7bfa39c12.png')
  background-size: contain
  background-position: center
  position: relative
  padding-bottom: 0
  // h1
  //   padding-top: 45px
  //   height: 87px
  //   line-height: 87px
  //   font-size: 34px
  //   color: #fff
  //   text-align: center
  .container
    height: 100%
    background-image: url('https://static.geekbang.org/archsummit/2017sz-mountain2.png')
    background-size: 110%
    background-position: bottom
    background-repeat: no-repeat
    position: relative
    bottom: -38px
  a
    position: absolute
    display: flex
    flex-direction: column
    align-items: center
    color: white
    font-size: 22px
    cursor: pointer
    .line
      border-left: 1px solid #fff
    .dot
      border-radius: 50%
      position: relative
      .in
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        background-color: white
        border-radius: 50%
        z-index: 2
      .out
        position: absolute
        left: 50%
        top: 50%
        width: 280%; height: 280%
        margin: -140% 0 0 -140%
        background-color: white
        border-radius: 50%
        z-index: 1
        opacity: 0.5
  a.y2014, a.y2019
    font-size: 14px
    .line
      height: 22px
    .dot
      $size: 10px
      width: $size
      height: $size
  a.y2015, a.y2016.sz
    font-size: 16px
    .line
      height: 30px
    .dot
      $size: 12px
      width: $size
      height: $size
  a.y2016, a.y2017
    font-size: 22px
    .line
      height: 35px
    .dot
      $size: 15px
      width: $size
      height: $size
  a.y2014.bj
    top: 198px
    left: 559px
  a.y2015.bj
    top: 95px
    left: 666px
  a.y2016.bj
    top: 90px
    left: 795px
  a.y2016.sz
    top: 180px
    left: 218px
  a.y2017.sz
    top: 190px
    left: 328px
  a.y2019.sz
    top: 158px
    left: 905px
  a.y2019.bj
    top: 265px
    left: 992px
  a.animate .dot
    animation: ashomehistoryblink 0.6s linear infinite alternate
</style>
